import { Box, Button, IconButton, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import AccessControl from "@/components/AccessControl/AccessControl";
import type { TAB_STATUSES } from "@/constants/index.js";

import { ExpMenu as ExpMenuIcon, RightMenu } from "../../../icons";
import { setDashboard } from "../MainHeader/MainHeaderDataSlice";

interface NoContentItemsProps {
  readonly propertyId: string | number;
  readonly tabStatus: TAB_STATUSES;
}

export default function NoContentItems(props: NoContentItemsProps) {
  const { propertyId, tabStatus } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        width: "100%",
        position: "absolute",
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: 1203,
        background: "#424242",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        top: tabStatus === "homebase" ? "0" : "40px",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          background: "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%)",
          backdropFilter: "blur(4px)",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 15px",
        }}
      >
        <IconButton
          aria-label="open drawer"
          edge="start"
          sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          size="large"
        >
          <ExpMenuIcon />
        </IconButton>
        <IconButton
          edge="end"
          color="inherit"
          aria-label="open drawer"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          size="large"
        >
          <RightMenu />
        </IconButton>
      </Box>
      <AccessControl
        allowedPermissions={["media_items:read"]}
        renderNoAccess={() => (
          <Typography sx={{ fontSize: "16px", lineHeight: "24px", color: "#D9D9D9" }} variant="body1">
            Empty showcase? No worries! Just a quick heads up that you&apos;ll need some asset items assigned to get
            started. Touch base with your property administrator to get the ball rolling!
          </Typography>
        )}
      >
        <Typography sx={{ fontSize: "16px", lineHeight: "24px", color: "#D9D9D9" }} variant="body1">
          No Asset items have been added to the Asset Library
        </Typography>
        <Button
          sx={{ marginTop: "16px", width: "312px", height: "40px", borderRadius: "24px" }}
          onClick={() => {
            dispatch(setDashboard({ dashboardStatus: true }));
            navigate(`/properties/${propertyId}/media`);
          }}
          variant="contained"
          color="primary"
        >
          Go To The Asset Library
        </Button>
      </AccessControl>
    </Box>
  );
}
